/**
 * Centralized collection name helper.
 * Prefixes all Firestore collection names with the environment (dev_ or prod_).
 *
 * Set VITE_FIREBASE_ENV=dev  → dev_cycles, dev_userRoles
 * Set VITE_FIREBASE_ENV=prod → prod_cycles, prod_userRoles
 */

export const ENV = import.meta.env.VITE_FIREBASE_ENV || 'dev';
const prefix = `${ENV}_`;

export const COLLECTIONS = {
  cycles: `${prefix}cycles`,
  userRoles: `${prefix}userRoles`,
  // Subcollection names (under cycles) — no prefix needed since they're nested
  compensations: 'compensations',
  reportingLines: 'reportingLines',
};
